import { Popover, Position } from "@blueprintjs/core"
import { ColorPicker } from "src/libs/useful"

const ColorExample = ({value, field, onChange, isHideInput, minimal}: any) : JSX.Element => {
    const onColor = (color: any) => { 
        if( onChange) {
            onChange( color, field, "" )
        }
    }
    const _onChange = (fileData: any ) => {
        if( onChange)  onChange( fileData,  field, "" )
    }
    return minimal 
        ?
        <div>
            <div className="d-flex w-100">
                <Popover
                    position={ Position.TOP }
                    content={ <ColorPicker color={ value || "#FFFFFF" } onChoose={ onColor } /> } 
                    portalClassName='z-index-130'
                >            
                    <div 
                        className='pe-color-picker-example' 
                        style={{backgroundColor: value || "#FFFFFF"}}
                        onClick={(evt:any) => { evt.stopPropagation(); evt.preventDefault(); }}            
                        onDrag={(evt:any) => { evt.stopPropagation(); evt.preventDefault(); }}            
                    /> 
                </Popover> 
                {
                    !isHideInput && <input
                        type="string"
                        className="form-control input dark"
                        value={ value  === null || value?.indexOf( "var(" ) > -1 ? "" : value }
                        onChange={ (evt: any) => {
                            _onChange( evt.currentTarget.value ) 
                            evt.preventDefault()
                            evt.stopPropagation();
                        }}          
                        onDrag={(evt:any) => { evt.stopPropagation(); evt.preventDefault(); }}    
                    />
                }
            </div>
        </div>
        :
        <div>
            <ColorPicker color={ value || "#FFFFFF" } onChoose={ onColor } /> 
            {
                !isHideInput && <input
                    type="string"
                    className="form-control input dark"
                    value={ value  === null || value?.indexOf( "var(" ) > -1 ? "" : value }
                    onChange={ (evt: any) => {
                        _onChange( evt.currentTarget.value ) 
                        evt.preventDefault()
                        evt.stopPropagation();
                    }}          
                    onDragStart={(evt:any) => { evt.stopPropagation(); evt.preventDefault(); }}    
                    onDrag={(evt:any) => { evt.stopPropagation(); evt.preventDefault(); }}    
                />
            } 
        </div>      
} 

export default ColorExample